/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning quiz question type values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_QUIZ_QUESTION_TYPES } from '@shared/constants';
 * 
 * if (question.type === LEARNING_QUIZ_QUESTION_TYPES.MULTIPLE_CHOICE) {
 *   // Handle multiple choice question
 * }
 * ```
 */
export const LEARNING_QUIZ_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multiple_choice',
  TRUE_FALSE: 'true_false',
  SHORT_ANSWER: 'short_answer',
  CODE_CHALLENGE: 'code_challenge'
} as const; 